import styled from 'styled-components'

const ArticleIndividualStyle = styled.div`
	--arrowMarginLeftRight: var(--sp2x);
	--pathWrapPadding: var(--sp4x) 0;
	--pageTopPaddingLeftRight: 0 var(--sp8x);
	--mainContentMarginTop: var(--sp13x);
	--infoMaxWidth: var(--sp88x);
	--infoMarginRight: var(--sp5x);
	--sliderPaddingTopBottom: var(--sp21x);
	--arrowSizes: var(--sp2x);

	.page-top {
		padding: var(--pageTopPaddingLeftRight);

		.path-wrap {
			padding: var(--pathWrapPadding);
		}
	}

	.main-content-wrap {
		display: flex;
		margin-top: var(--mainContentMarginTop);

		.info {
			max-width: var(--infoMaxWidth);
			margin-right: var(--infoMarginRight);
			width: 100%;
		}

		.content {
			width: 100%;
		}
	}

	.slider-wrap {
		padding: var(--sliderPaddingTopBottom) 0;
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--pageTopPaddingLeftRight: 0 var(--sp6x);
		--arrowMarginLeftRight: var(--sp1-5x);
		--pathWrapPadding: var(--sp3x) 0;
		--mainContentMarginTop: var(--sp10x);
		--infoMarginRight: var(--sp4x);
		--infoMaxWidth: var(--sp70x);
		--sliderPaddingTopBottom: var(--sp15x);
		--arrowSizes: var(--sp1-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--pageTopPaddingLeftRight: 0 var(--sp6x);
		--arrowMarginLeftRight: var(--sp1x);
		--pathWrapPadding: var(--sp3x) 0;
		--mainContentMarginTop: var(--sp8x);
		--infoMarginRight: var(--sp3x);
		--infoMaxWidth: var(--sp57x);
		--sliderPaddingTopBottom: var(--sp12x);
		--arrowSizes: var(--sp1-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--pageTopPaddingLeftRight: 0 var(--sp5x);
		--arrowMarginLeftRight: var(--sp1x);
		--pathWrapPadding: var(--sp2x) 0;
		--mainContentMarginTop: var(--sp8x);
		--infoMarginRight: var(--sp3x);
		--infoMaxWidth: var(--sp53x);
		--sliderPaddingTopBottom: var(--sp12x);
		--arrowSizes: var(--sp1-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--pageTopPaddingLeftRight: 0 var(--sp4x);
		--arrowMarginLeftRight: var(--sp1x);
		--pathWrapPadding: var(--sp2x) 0;
		--mainContentMarginTop: var(--sp5x);
		--infoMarginRight: var(--sp3x);
		--infoMaxWidth: var(--sp56x);
		--sliderPaddingTopBottom: var(--sp10x);
		--arrowSizes: var(--sp1-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--pageTopPaddingLeftRight: 0 var(--sp4x);
		--arrowMarginLeftRight: var(--sp1x);
		--pathWrapPadding: var(--sp2x) 0;
		--mainContentMarginTop: var(--sp5x);
		--infoMarginRight: var(--sp3x);
		--infoMaxWidth: var(--sp42x);
		--sliderPaddingTopBottom: var(--sp8x);
		--arrowSizes: var(--sp1-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--pageTopPaddingLeftRight: 0 var(--sp3x);
		--arrowMarginLeftRight: var(--sp1x);
		--pathWrapPadding: var(--sp2x) 0;
		--mainContentMarginTop: var(--sp5x);
		--infoMarginRight: 0;
		--infoMaxWidth: 100%;
		--sliderPaddingTopBottom: var(--sp8x);
		--arrowSizes: var(--sp1-5x);

		.main-content-wrap {
			flex-direction: column;

			.content {
				margin-top: var(--sp2x);
			}
		}
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--pageTopPaddingLeftRight: 0 var(--sp3x);
		--arrowMarginLeftRight: var(--sp1x);
		--pathWrapPadding: var(--sp2x) 0;
		--mainContentMarginTop: var(--sp5x);
		--infoMarginRight: 0;
		--infoMaxWidth: 100%;
		--sliderPaddingTopBottom: var(--sp6x);
		--arrowSizes: var(--sp1-5x);

		.main-content-wrap {
			flex-direction: column;

			.content {
				margin-top: var(--sp2x);
			}
		}
	}
`

export default ArticleIndividualStyle
